import React from 'react';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import { portfolio } from '../../data/mockData';
import { useLanguage } from '../../context/LanguageContext';
import { TrendingDown, Wallet, Building2 } from 'lucide-react';

export default function PortfolioSection() {
  const { t, tl, lang } = useLanguage();
  const [sectionRef, isVisible] = useScrollReveal({ threshold: 0.1 });

  return (
    <section id="portfolio" className="py-16 sm:py-24 lg:py-32 bg-[#0a0a0c]">
      <div ref={sectionRef} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 animate-reveal ${isVisible ? 'visible' : ''}`}>
        <div className="flex items-center gap-4 mb-6">
          <span className="text-[#c9a96e] text-xs font-semibold tracking-[0.25em] uppercase">{t('portfolio_label')}</span>
          <div className="h-px flex-1 bg-[#2a2a30]" />
        </div>

        <div className="max-w-2xl mb-10 sm:mb-16">
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-[#f0ebe3] leading-tight">
            {t('portfolio_h2_1')}
            <span className="text-gold-gradient block mt-1">{t('portfolio_h2_2')}</span>
          </h2>
          <p className="text-[#8a857e] text-sm sm:text-base leading-relaxed mt-4 sm:mt-6">{t('portfolio_sub')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {portfolio.map((item, i) => (
            <div
              key={i}
              className={`p-5 sm:p-6 border border-[#1e1e24] rounded-xl bg-[#111114]/60 service-card gold-glow animate-reveal ${isVisible ? 'visible' : ''}`}
              style={{ transitionDelay: `${0.1 + i * 0.06}s` }}
            >
              <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-[#c9a96e]/8 flex items-center justify-center mb-4 sm:mb-5">
                <Building2 className="w-4 h-4 sm:w-5 sm:h-5 text-[#c9a96e]/60" />
              </div>
              <h4 className="text-[#f0ebe3] font-medium text-sm sm:text-[15px] mb-1 leading-snug">{item.company}</h4>
              {item.former && <p className="text-[#6a6560] text-xs mb-1">{lang === 'ro' && item.formerRo ? item.formerRo : item.former}</p>}
              {item.note && <p className="text-[#c9a96e]/50 text-xs font-medium mb-3">({tl(item.note)})</p>}
              {!item.former && !item.note && <div className="mb-3" />}
              <div className="flex gap-5 sm:gap-6 pt-3 sm:pt-4 border-t border-[#1e1e24]">
                <div className="flex items-center gap-2">
                  <TrendingDown className="w-3.5 h-3.5 text-[#8b3030]" />
                  <div>
                    <p className="text-[#6a6560] text-[10px] uppercase tracking-wider">{t('portfolio_debts')}</p>
                    <p className="text-[#f0ebe3] text-xs sm:text-sm font-medium">{item.debts}</p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <Wallet className="w-3.5 h-3.5 text-[#c9a96e]" />
                  <div>
                    <p className="text-[#6a6560] text-[10px] uppercase tracking-wider">{t('portfolio_assets')}</p>
                    <p className="text-[#f0ebe3] text-xs sm:text-sm font-medium">{item.assets}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
